import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './ToggleTabGroup.css';
import Tooltip from '../molecules/Tooltip';
import { Icon } from '../widgets';
import { IconSizes } from '../foundations/Icon';

const WIDTH_PER_CHAR = 9;
const TOOLTIP_WIDTH = 4;

const ToggleTabGroup = ({ options, selectedOption, onToggle, isSeparateTabs = false }) => {
    const maxButtonWidth = Math.max(
        ...options.map(({ label, tooltip }) => label.length + (tooltip ? TOOLTIP_WIDTH : 0))
    );
    const tabsShouldBeEqual = options.length === 2;

    return (
        <div className={css.root}>
            {options.map(({ option, label, tooltip, disabled }, i) => (
                <button
                    className={classNames(css.button, {
                        [css.active]: selectedOption === option,
                        [css.separateTab]: isSeparateTabs,
                        [css.firstButton]: i === 0 && !isSeparateTabs,
                        [css.lastButton]: i === options.length - 1 && !isSeparateTabs,
                        [css.equalTabs]: tabsShouldBeEqual && !isSeparateTabs,
                        [css.disabled]: disabled,
                    })}
                    style={{ '--dynamicWidth': tabsShouldBeEqual ? `${maxButtonWidth * WIDTH_PER_CHAR}px` : 'initial' }}
                    onClick={() => onToggle(option)}
                    type="button"
                    key={option}
                    disabled={disabled}
                >
                    <span className={css.label}>{label}</span>
                    {tooltip && (
                        <Tooltip title={tooltip} wrapperClass={css.tooltipWrapper}>
                            <Icon name="help-circle" size={IconSizes.SMALL} />
                        </Tooltip>
                    )}
                </button>
            ))}
        </div>
    );
};

ToggleTabGroup.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            option: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            tooltip: PropTypes.string,
            disabled: PropTypes.bool,
        })
    ).isRequired,
    selectedOption: PropTypes.string.isRequired,
    onToggle: PropTypes.func.isRequired,
    isSeparateTabs: PropTypes.bool,
};

export default ToggleTabGroup;
